import { render, staticRenderFns } from "./StrapiCatalogueComponent.vue?vue&type=template&id=1b9c49f6"
import script from "./StrapiCatalogueComponent.vue?vue&type=script&lang=js"
export * from "./StrapiCatalogueComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports